export default "__VITE_ASSET__DKL6BIRR__"